<template>
    <div class="col-lg-12 table-row" :class="{mock: !hasData}">
        <div class="row" @click="select">
            <div class="col-lg-4 table-column campaign-name header-border">
                <span :class="[status.toLowerCase()]" v-text="$tc(`facebook.ads.${status.toLowerCase()}`, 1)"/>
                <span v-text="title"/>
            </div>

            <!-- DESKTOP -->
            <div class="col-lg-8 hidden-md hidden-sm hidden-xs">
                <div class="row">
                    <div class="col-lg-2 table-column insight-value text-center"
                         v-tooltip="showCTR(metric)"
                         v-for="metric in metrics">
                        <small v-if="!hasData" v-text="123"/>
                        <small v-else-if="objectWithInsights.insights[metric.metric]" v-html="objectWithInsights.insights[metric.metric]"/>
                        <small v-else v-text="'-'"/>
                    </div>
                </div>
            </div>

            <!-- MOBILE -->
            <div class="col-sm-12 col-xs-12 col-md-12 hidden-lg">
                <div class="row mobile-container">
                    <div v-for="metric in metrics" class="fb-tb-ads-row">
                        <div class="col-md-4 col-sm-4 col-xs-6 table-column insight-explainer-icon table-col--border-right">
                            <i class="fa" :class="metric.icon"/>
                            <small class="table-header__text" v-text="$t(`facebook.ads.insights.${metric.metric}`)"/>
                        </div>
                        <div class="col-md-8 col-sm-8 col-xs-6 table-column insight-value text-center">
                            <small v-if="!hasData" v-text="123"/>
                            <small v-else-if="objectWithInsights.insights[metric.metric]" v-html="objectWithInsights.insights[metric.metric]"/>
                            <small v-else v-text="'-'"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <slot/>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'FacebookAdsTableRow',
    props: {
      type: {
        type: String,
        default: 'mock'
      },
      campaign: {
        type: Object | Number,
        default: null
      },
      adSet: {
        type: Object | Number,
        default: null
      },
      ad: {
        type: Object | Number,
        default: null
      },
      status: {
        required: true,
        type: String
      }
    },
    data () {
      return {
        objectWithInsights: null
      }
    },
    computed: {
      ...mapGetters('facebookAds', {
        selected: 'getSelected',
        metrics: 'getMetrics'
      }),
      hasData () {
        return this.objectWithInsights
      },
      isCampaign () {
        return !!this.selected(this.status).campaign
      },
      isAdSet () {
        return !!this.selected(this.status).adSet
      },
      isAd () {
        return !!this.selected(this.status).ad
      },
      isSelected () {
        if (!this.hasData) {
          return false
        }

        const { campaign, ad, adSet } = this.selected(this.status)

        if (this.isCampaign && this.objectWithInsights.id === campaign.id) {
          return true
        }

        if (this.isAdSet && this.objectWithInsights.id === adSet.id) {
          return true
        }

        if (this.isAd && this.objectWithInsights.id === ad.id) {
          return true
        }
      },
      title () {
        return this.hasData ? this.objectWithInsights.name : 'Kampagne navn'
      }
    },
    mounted () {
      if ((this.campaign && this.campaign.id) || (this.adSet && this.adSet.id) || (this.ad && this.ad.id)) {
        this.loadInsights()
      }
    },
    methods: {
      showCTR (object) {
        if (object.metric === 'outbound_clicks' && this.objectWithInsights) {
          const label = $t(`facebook.ads.insights.outbound_clicks_ctr`)
          const ctr = this.objectWithInsights.insights.outbound_clicks_ctr

          return ctr ? `${label}: ${ctr}` : ''
        }

        return ''
      },
      async loadInsights () {
        this.objectWithInsights = await this.$store.dispatch('facebookAds/loadInsights', {
          adSet: this.adSet,
          campaign: this.campaign,
          ad: this.ad,
          status: this.status
        })
      },
      select () {
        if (this.type !== 'mock') {
          this.$store.dispatch('facebookAds/select', {
            object: this.objectWithInsights,
            status: this.status,
            type: this.type
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .campaigns .table-row .row.mock .table-column.campaign-name {
        cursor: default;
    }
</style>
